import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

const mainURL = `api/v1/products-app/products`;

//obtaining the paginated data
export const getItem = ({ rowsPerPage, search, sortOrder, pageNo }) =>
  axiosInstance.get(`${mainURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`);

//obtaining all fiscal sessions
export const getAllItem = (sortOrder) => axiosInstance.get(`${mainURL}/list?ordering=${sortOrder}`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageItem = ({ number, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${mainURL}/list?offset=${(number - 1) * rowsPerPage}&limit=${rowsPerPage}&ordering=${sortOrder}`);

export const createItem = (body) => axiosInstance.post(`${mainURL}/create-all`, body);

export const getItemById = (id) => axiosInstance.get(`${mainURL}/retrieve-all/${id}`);

export const updateItem = (body, id) => axiosInstance.patch(`${mainURL}/update-all/${id}`, body);

// api/v1/products-app/products//1

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${mainURL}/list?offset=0&limit=${rowsPerPage}&search=${search}&ordering=${sortOrder}`);

// checking the redundant data
export const checkRedundantDataItemName = (e, cancelToken) =>
  axiosInstance.get(`${mainURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
export const checkRedundantDataItemCode = (e, cancelToken) =>
  axiosInstance.get(`${mainURL}/list?code=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
